import React from 'react';
import PortalRenderer from 'src/components/RenderViewFromTemplate/PortalRenderer';
import { IComponent } from 'src/common/helpers/handleFunctions';


interface MultiPortalRendererProps {
	components: IComponent<object>[];
}

const MultiPortalRenderer = ({ components, }: MultiPortalRendererProps) => {
	return (
		<>
			{components.map((comp) => (
				<PortalRenderer
					key={comp.id}
					containerId={comp.id}
					component={comp.component}
					componentProps={comp.props}
				/>
			))}
		</>
	);
};

export default MultiPortalRenderer;
